import React, { useEffect, useState } from 'react';
import { LeafIcon, CheckCircleIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function HeroSection() {
  const checkoutUrl = 'https://ewordmedia.com/cart/48415277515004:1?checkout';
  const bookImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/a1Nn5vs4NUhZzwizr1q9sj/1.Natural_remedies_and_herbal_guidebooks.png',
    alt: 'The Complete Natural Healing Bundle — all three guides'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/bbPh1sUZRwfCXRzyqmTcfN/2.Natural_remedies_and_herbal_guidebooks.png',
    alt: 'The Complete Natural Healing Bundle — clean background'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/icmCjE8iESpbgMhLJbRFtr/3.Natural_remedies_and_herbal_guidebooks.png',
    alt: 'The Natural Remedy Survival Guide — front cover'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ntotBQjZxQjKZpEVriGK5V/4.Natural_remedies_and_herbal_guidebooks.png',
    alt: 'The Natural Remedy Survival Guide — cover detail'
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % bookImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  return <section className="w-full bg-gradient-to-b from-emerald-50 to-stone-50 py-16 md:py-24" data-id="element-501">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-502">
        <div className="text-center flex flex-col items-center" data-id="element-503">
          {/* Eyebrow */}
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-504">
            <LeafIcon className="w-5 h-5 text-emerald-700" data-id="element-505" />
            <span className="text-emerald-700 font-semibold tracking-wide uppercase text-sm" data-id="element-506">
              Natural Healing
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-stone-900 mb-5 leading-tight tracking-tight" data-id="element-507">
            The Natural Remedy Survival Guide
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-stone-600 mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-508">
            Support common health issues at home using simple kitchen
            ingredients instead of expensive prescriptions.
          </p>

          {/* Supporting line */}
          <p className="text-base md:text-lg text-stone-500 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-509">
            Discover the forgotten natural remedies hidden in your kitchen
            cabinet — and how to use them safely for everyday wellness.
          </p>

          {/* Book Image Carousel */}
          <div className="w-full max-w-lg mx-auto mb-10 relative" data-id="element-510">
            <div className="absolute inset-0 bg-emerald-200 blur-3xl opacity-20 rounded-full" data-id="element-511"></div>
            <div className="relative z-10" data-id="element-512">
              <img src={bookImages[activeIndex].src} alt={bookImages[activeIndex].alt} className="w-full h-auto object-contain drop-shadow-2xl transition-opacity duration-500 rounded-lg" data-id="element-513" />
              {/* Arrow buttons */}
              <button onClick={() => setActiveIndex(prev => (prev - 1 + bookImages.length) % bookImages.length)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md transition-colors" aria-label="Previous image" data-id="element-514">
                <ChevronLeftIcon className="w-5 h-5 text-stone-700" data-id="element-515" />
              </button>
              <button onClick={() => setActiveIndex(prev => (prev + 1) % bookImages.length)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md transition-colors" aria-label="Next image" data-id="element-516">
                <ChevronRightIcon className="w-5 h-5 text-stone-700" data-id="element-517" />
              </button>
            </div>
            {/* Dot indicators */}
            <div className="flex items-center justify-center gap-2 mt-4 relative z-10" data-id="element-518">
              {bookImages.map((_, index) => <button key={index} onClick={() => setActiveIndex(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === activeIndex ? 'bg-emerald-600 scale-110' : 'bg-stone-300 hover:bg-stone-400'}`} aria-label={`View image ${index + 1}`} data-id="element-519" />)}
            </div>
          </div>

          {/* Guide list */}
          <div className="bg-white/80 backdrop-blur-sm border border-emerald-100 rounded-2xl p-6 md:p-8 mb-8 shadow-sm w-full max-w-xl mx-auto text-left" data-id="element-520">
            <h2 className="font-bold text-stone-900 text-2xl mb-2 text-center" data-id="element-521">
              The Complete Natural Healing Bundle
            </h2>
            <p className="text-stone-600 text-base mb-5 text-center" data-id="element-522">
              Includes these 3 practical guides:
            </p>
            <ul className="space-y-4" data-id="element-523">
              <li className="flex items-start gap-3" data-id="element-524">
                <CheckCircleIcon className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-525" />
                <span className="text-stone-800 font-medium text-lg" data-id="element-526">
                  The Natural Remedy Survival Guide
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-527">
                <CheckCircleIcon className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-528" />
                <span className="text-stone-800 font-medium text-lg" data-id="element-529">
                  Herbal First Aid — Your Natural Emergency Toolkit
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-530">
                <CheckCircleIcon className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-531" />
                <span className="text-stone-800 font-medium text-lg" data-id="element-532">
                  The Backyard Herbal Medicine Garden
                </span>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <a href={checkoutUrl} data-cta="hero" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart');
          }
        }} className="inline-flex items-center justify-center gap-2 w-full sm:w-auto bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 focus:from-emerald-600 focus:to-emerald-700 focus:outline-none focus:ring-4 focus:ring-emerald-300 text-white px-10 py-5 rounded-2xl text-xl font-bold transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1 transform mb-6" data-id="element-533">
            <span data-id="element-534">Only $17 Today</span>
            <span className="text-2xl leading-none" data-id="element-535">›</span>
          </a>

          {/* Trust line */}
          <div className="flex items-center justify-center gap-2 text-sm text-stone-500 mb-5 flex-wrap" data-id="element-536">
            <span data-id="element-537">Secure checkout</span>
            <span className="text-stone-400" data-id="element-538">•</span>
            <span data-id="element-539">Instant digital access</span>
            <span className="text-stone-400" data-id="element-540">•</span>
            <span data-id="element-541">30-day money-back guarantee</span>
          </div>

          {/* Value line */}
          <p className="text-center text-stone-600 text-lg mb-6" data-id="element-542">
            <span className="font-semibold" data-id="element-543">Total value: </span>
            <span className="line-through text-stone-400" data-id="element-544">$51</span>
            <span className="text-emerald-700 font-bold ml-1" data-id="element-545">
              {' '}
              • You save $34
            </span>
          </p>

          {/* Micro-benefits */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-stone-700 text-sm md:text-base font-medium" data-id="element-546">
            <span className="flex items-center gap-1.5" data-id="element-547">
              <CheckCircleIcon className="w-5 h-5 text-emerald-600" data-id="element-548" />
              Beginner friendly
            </span>
            <span className="flex items-center gap-1.5" data-id="element-549">
              <CheckCircleIcon className="w-5 h-5 text-emerald-600" data-id="element-550" />
              No special equipment required
            </span>
            <span className="flex items-center gap-1.5" data-id="element-551">
              <CheckCircleIcon className="w-5 h-5 text-emerald-600" data-id="element-552" />
              Uses ingredients found in your kitchen
            </span>
          </div>
        </div>
      </div>
    </section>;
}